module.exports = __webpack_public_path__ + "static/fayber-9c26d5b9f4407b558d866470205863cb.jpg";